module.exports = __webpack_public_path__ + "848a4e3e94b40eb707dae30be3cdf270.png";